import { Injectable } from '@angular/core';
import { InMemoryDbService, RequestInfo } from 'angular-in-memory-web-api';
import { Observable } from 'rxjs';
import { ResponseOptions } from '@angular/http';
import { ok } from 'assert';
import { HttpClient } from '@angular/common/http';

export const InMemoryServiceConfig = { delay: 1000 };

@Injectable()
export class InMemoryService implements InMemoryDbService {
    constructor() { }

    createDb() {
        const SelfServices = [];
        return { SelfServices };
    }
    worngCode:number=0;

    protected responseInterceptor(res: ResponseOptions, ri: RequestInfo): ResponseOptions {
        if (ri.method == "post") {
            if(ri.url == "api/SelfServices/restartLogin"){
                if(ri.collection[0].option)
                res.body =  {"isError":false,"isCaptchaNeeded":false}
              
            }
            else if(ri.url == "api/SelfServices/loginWithIdAndMobile" ||ri.url == "api/SelfServices/loginOtpOnly" ){             
              if(ri.req){
             if(ri.collection[1].HIN_MOBILE == "0556789207" && ri.collection[1].HIN_ID == "315249839"){
                  res.body ={"isError":false,"isCaptchaNeeded":false,"isPasswordExpiring":false,"otpDestMasked":"xxxxxx9207"};
             }
             else  if(ri.collection[1].HIN_MOBILE == "0556789202" && ri.collection[1].HIN_ID == "315249839"){
              res.body ="<html></html>";
         }
           else  if(ri.collection[1].HIN_MOBILE == "0556789201" && ri.collection[1].HIN_ID == "315249839"){
              res.body ="<html></html>";
         }
                 else{
                res.body={"isError":true,"isCaptchaNeeded":false,"isPasswordExpiring":false,"errorCode":"USER_NOT_FOUND"}
            }
            }
          
            }
            else if(ri.url == "api/SelfServices/loginWithIdAndPassword" || ri.url == "api/SelfServices/loginViaPassword"  ){
              if(ri.req){
                debugger
                    if(ri.collection[1].HIN_USERID == "123456" && ri.collection[1].Ecom_Password == "654321"){
                    res.body ={"isError":false, "isPasswordExpiring":false, "otpDestMasked":"xxxxxx9207"};
                }
                else if(ri.collection[1].HIN_USERID == "11111" && ri.collection[1].Ecom_Password == "654321"){
                  res.body ={"isError":false,"isCaptchaNeeded":false, "isPasswordExpiring":true}
                }
                else if(ri.collection[1].HIN_USERID == "11111" && ri.collection[1].Ecom_Password == "654321"){
                  res.body ={"isError":false,"isCaptchaNeeded":false, "isPasswordExpiring":true}
                }
                else if(ri.collection[1].HIN_USERID == "111111" && ri.collection[1].Ecom_Password == "777777"){
                  res.body ={"isError":true,"isCaptchaNeeded":false,"errorCode":"INTRUDER_DETECTED" ,"isPasswordExpiring":false}
                }
                else{
                  res.body ={"isError":true,"isCaptchaNeeded":false,"errorCode":"WRONG_USERNAME_OR_PASSWORD" ,"isPasswordExpiring":false}

                }
                  }
            }
            
            else if(ri.url == "api/SelfServices/sendOtp"){
              
                if(ri.collection[2].Ecom_Token =="123456"){
                    res.body ={"isError":false};
                }
                else if(ri.collection[2].Ecom_Token =="111111"){
                  res.body ={"isError":true,"isCaptchaNeeded":false,"errorCode":"PASSWORD_EXPIRED","otpDestMasked":"xxxxxx9961" , "restartCode":true}

                }
                else if(ri.collection[2].Ecom_Token =="777777"){
                  res.body ={"isError":true,"isCaptchaNeeded":false,"errorCode":"INTRUDER_DETECTED","otpDestMasked":"xxxxxx9961" , "restartCode":true}

                }
                else if(ri.collection[2].Ecom_Token =="666666"){
                  res.body ={"isError":true,"isCaptchaNeeded":false,"errorCode":"TOKEN_TOKEN_EXPIRED","otpDestMasked":"xxxxxx9961" , "restartCode":true}

                }
                else if(ri.collection[2].Ecom_Token =="555555"){
                  res.body ="<html?>"

                }
                else{
                    if(this.worngCode == 3){
                        res.body ={"isError":true,"isCaptchaNeeded":false,"errorCode":"TOKEN_TOKEN_EXPIRED","otpDestMasked":"xxxxxx9961" , "restartCode":true}
                        this.worngCode = 0;
                    }
                  else
                    res.body ={"isError":true,"isCaptchaNeeded":false,"isPasswordExpiring":false,"errorCode":"WRONG_TOKEN","otpDestMasked":"xxxxxx9207"}
                      this.worngCode++;
                }
            }
            else if(ri.url == "api/SelfServices/urlToGov"){  
                if(ri.collection[3].target!=""){                        
                res.body = { "isError":false , "target": ri.collection[3].target}
                } 
                
              }

        }
        else if (ri.method == "get") {
            if (ri.resourceUrl.startsWith("api/SelfServices/") && ri.url.indexOf("GetPhonePreffix") > 0) {
                res.body = [{ Code: '001' }, { Code: '002' }, { Code: '003' }, { Code: '058' }, { Code: '005' }, { Code: '006' }, { Code: '007' }, { Code: '054' }, { Code: '052' }]
            }
            else if (ri.resourceUrl.startsWith("api/SelfServices/") && ri.url.indexOf("VerifyOtp") > 0) {
                if (ri.url.indexOf("111111") > 0)
                    res.status = 200;
                else if (ri.url.indexOf("999999") > 0)
                    res.status = 500;
                else res.status = 400;
                return res;
                //res.body = [];

            }
            else if(ri.resourceUrl.startsWith("api/SelfServices/") && ri.url.indexOf("config.json") > 0)
            {
                res.body ={
                    "baseUrl2ApiCalls": "http://localhost:58437/",
                    "ReCaptcha": {
                      "SiteKey": "6LctmPscAAAAAD_wZV1ZJtOKmHgaVqjgOIYOWD9_"
                    },
                    "CommonQuestions": [
                      {
                        "Question": "מי רשאי להיכנס באמצעות מערכת ההזדהות הלאומית?",
                        "Answer": "כל הורה או אזרח. עובדי הוראה, סגל בית הספר, עובדי משרד החינוך או עובדי רשות מקומית יכולים להיכנס באמצעות הזדהות לאומית."
                      },
                      {
                        "Question": "מי רשאי להיכנס באמצעות הזדהות משרד החינוך?",
                        "Answer": "עובדי הוראה, סגל בית הספר, עובדי משרד החינוך או עובדי רשות מקומית יכולים להיכנס לפורטל באמצעות הזדהות משרד החינוך. הורים שנרשמו לפורטל ומחזיקים בחשבון הזדהות משרד החינוך מתבקשים להירשם למערכת ההזדהות הלאומית במהלך שנת 2022."
                      },
                      {
                        "Question": "לחצתי על הזדהות משרד החינוך וקיבלתי הודעה: המשתמש אינו קיים במערכת. מה עלי לעשות?",
                        "Answer": "יש לחזור לדף ההזדהות המשולב שבלשונית הקודמת ולבחור: הזדהות/רישום למערכת ההזדהות הלאומית."
                      },
                      {
                        "Question":"האם יש הבדל בין שני סוגי ההזדהות?",
                        "Answer":"לא, לאחר ההזדהות בכל אחת מהדרכים ייחשף אותו מידע ויינתנו אותן האפשרויות."
                      },
                      {
                        "Question":"באיזה דפדפנים נתמך הדף?",
                        "Answer":"בדפדפנים: edge, Chrome מגרסה 79 ומעלה ו-safari."
                      }
                    ],
                    "phonePrefix": [
                      { "phoneCode": "050", "value": "050" },
                      { "phoneCode": "052", "value": "052" },
                      { "phoneCode": "053", "value": "053" },
                      { "phoneCode": "054", "value": "054" },
                      { "phoneCode": "057", "value": "055" },
                      { "phoneCode": "058", "value": "058" },
                      { "phoneCode": "055", "value": "055" }
                    ],
                    
                    "logoutTime":{
                      "timeOutLogout": 2,
                      "timeOutToShowMessage":1
                      },
                      "phoneSupport":"6552*",
                      "phoneSupportMoe":"6552*",
                      "timeUserLocked":"1",

                    "Links":{
                      "updateDetails":"http://itest20121/nta/AlfonPratimNosafim.aspx",
                      "resetPassword":"http://appslimud.education.gov.il/EduLogin/SelfReset.aspx",
                      "resetPasswordMoe":"https://tidmua.education.gov.il/sspr/public/forgottenpassword",
                      "SBSLogin":{ 
                         "userGuide":"https://meyda.education.gov.il/files/Mercaz_Meyda/guide_education/sbs.pdf ",
                         "informationalVideo":"https://youtu.be/KmlsUGORJjA"
                       },
                       "OtpOnlyLogin":{ 
                         "userGuide":"https://meyda.education.gov.il/files/Mercaz_Meyda/guide_education/otp_only.pdf",
                         "informationalVideo":"https://youtu.be/fIVT5r9B_-8"
                       }
                     },
                 
                  
                  
                  "supportedBrowsers":[ 
                    {"browser": "Edge", "version":78}, 
                    {"browser": "IE", "version":0}
                    ] 
                }
                // {
                    
                    //   "baseUrl2ApiCalls": "",
                    //   "ReCaptcha": {
                    //     "SiteKey": "6LcVidEaAAAAALZ-VM0MVGhzadKbM1WcGKoE_fyC"
                    //   }
                  //  };
            }
        }
        res.status = 200;
        return res;
    }
}